module.exports = __webpack_public_path__ + "static/media/cantanhede-1.75a0df1d.jpg";